<template>
    <div class="workday" :style="mainContentViewHeight">
        <div class="workday-top">
            <p>
                <span class="title">日程管理</span>
            </p>
            <div class="workday-search">
                <el-input placeholder="请输入日程消息" v-model="searchKey" clearable></el-input>
                <el-button class="search-btn" type="primary" @click="searchHandle">搜索</el-button>
            </div>
        </div>
        <div class="table-content">
            <el-button type="primary" size="medium" @click="addHandle">新增</el-button>
            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%;margin-top:16px;"
                :height="tableMaxHeight"
                @sort-change="sortChange"
                @filter-change="filterChange"
                size="mini"
            >
                <el-table-column
                    label="序号"
                    type="index"
                    width="80px"
                    align="center"
                    :index="indexMethod"
                ></el-table-column>
                <el-table-column 
                    v-for="item in columns" 
                    :key="item.id"
                    :label="item.label"
                    :type="item.type"
                    :width="item.width"
                    :align="item.align"
                    :min-width="item.minWidth"
                    :show-overflow-tooltip="item.showOverflowTooltip"
                    :prop="item.prop"
                    :column-key="item.columnKey"
                    :sortable="item.sortable"
                    :filters="item.filters"
                >
                    <template slot-scope="scope">
                        <!-- 紧急程度 -->
                        <el-tag v-if="item.domType === 'emergencyLevel'" :type="setType(scope.row.emergencyLevel)">{{scope.row.emergencyLevelText}}</el-tag>
                        <el-tag v-else-if="item.domType === 'completeStatus'" :type="scope.row.completeStatus==0?'warning':'success'">{{scope.row.completeStatusText}}</el-tag>
                        <!-- 完成情况 -->
                        <!-- 操作 -->
                        <div v-else-if="item.btns" class="table-btns">
                            <el-button type="text" size="mini" @click="completeHandler(scope.row)">完成</el-button>
                            <el-button type="text" size="mini" @click="changeHandler(scope.row)">修改</el-button>
                            <el-button type="text" size="mini" @click="deleteHandler(scope.row)">删除</el-button>
                        </div>
                        <span v-else>{{scope.row[item.prop]}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
            <pagination
                    class="limit"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="total"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange">
                </pagination>
        </div>
        <SchModal ref="SchModal" @on-sumit="sumitHandler"></SchModal>
    </div>
</template>

<script>
let columns = [
    {id:20,label:'日程标题',minWidth: '200',align:'left',prop: 'title'},
    {id:30,label:'紧急程度',width: '100',prop: 'emergencyLevel',columnKey:'emergencyLevel',align:'center',domType:'emergencyLevel',filters:[{text:'一般',value:1},{text:'重要',value:2},{text:'紧急',value:3}]},
    {id:40,label:'开始时间',minWidth: '160',prop: 'startTime',sortable: true,align:'center'},
    {id:50,label:'结束时间',minWidth: '160',prop: 'endTime',sortable: true,align:'center'},
    {id:60,label:'地点',minWidth: '160',showOverflowTooltip: true,prop: 'location',align:'left'},
    {id:70,label:'完成情况',minWidth: '100',columnKey:'completeStatus',prop: 'completeStatus',align:'center',domType:'completeStatus',filters:[{text:'未完成',value:0},{text:'已完成',value:1}]},
    {id:80,label:'备注',minWidth: '200',prop: 'remark',showOverflowTooltip: true},
    {id:90,label:'创建时间',width: '160',align:'center',prop: 'createTime',sortable: true},
    {id:100,label:'操作',width: '140px',align:'left',btns: true},
]
import SchModal from '@/components/SchModal';
import {
    apiwbschedulemanagementlist,
    apiwbschedulemanagementdelete,
    apiwbschedulemanagementupdateCompleteStatus
} from '@/server/new.js';
import Pagination from '@/components/Pagination.vue';
let emergencyLevelEnum = {
    1: '一般',
    2: '重要',
    3: '紧急'
}
let completeStatusEnum = {
    0: '未完成',
    1: '已完成'
}
export default {
    props: ['mainContentViewHeight'],
    components: {
        SchModal,
        Pagination
    },
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 88 - 20 - 60 - 40 - 44 - 20 - 110, //top筛选 边距 内边距 搜索 默认
            columns: columns,
            tableData: [],
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            searchKey: '',
            emergencyLevelData: [],
            completeStatusData: [],
            sortParams: {
                prop: '',
                order: ''
            }
        }
    },
    mounted() {
        this.apiwbschedulemanagementlist();
    },
    methods: {
        addHandle() {
            this.$refs.SchModal.open();
        },
        apiwbschedulemanagementlist() {
            apiwbschedulemanagementlist({
                page: this.pageIndex,
                rows: this.pageSize,
                searchKey: this.searchKey,
                filter: {
                    emergencyLevelList: this.emergencyLevelData,
                    completeStatusList: this.completeStatusData
                },
                orderBy: this.sortParams.prop && this.sortParams.order ? this.sortParams.prop+(this.sortParams.order == "ascending" ? " asc" : " desc"):''
            }).then(({data}) => {
                this.tableData = data.rows || [];
                this.tableData.map(item => {
                    item.emergencyLevelText = emergencyLevelEnum[item.emergencyLevel]
                    item.completeStatusText = completeStatusEnum[item.completeStatus]
                })
                this.total = data.total || 0;
            })
        },
        setType(item) {
            let emergencyLevelEnum = {
                1: null,
                2: 'warning',
                3: 'danger'
            }
            return emergencyLevelEnum[item] || null
        },
        completeHandler(row) {
            this.$confirm(`是否完成该条数据？`,'提示', {
                confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
            }).then(() => {
                apiwbschedulemanagementupdateCompleteStatus(row.id).then(({data}) => {
                    if(data.code === '1') {
                        this.$message({
                            type:'success',
                            message:'完成成功'
                        })
                        this.apiwbschedulemanagementlist();
                    }else {
                        this.$message({
                            type:'error',
                            message:data.msg
                        })
                    }
                })
            }).catch(() => {})
        },
        changeHandler(row) {
            this.$refs.SchModal.open(row.id);
        },
        deleteHandler(row) {
            this.$confirm(`是否删除该条数据？`,'提示', {
                confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
            }).then(() => {
                apiwbschedulemanagementdelete(row.id).then(({data}) => {
                    if(data.code === '1') {
                        this.$message({
                            type:'success',
                            message:'删除成功'
                        })
                        this.apiwbschedulemanagementlist();
                    }else {
                        this.$message({
                            type:'error',
                            message:data.msg
                        })
                    }
                })
            }).catch(() => {})
        },
        sumitHandler() {
            this.apiwbschedulemanagementlist();
        },
        searchHandle() { //搜索按钮
            this.pageIndex = 1;
            this.apiwbschedulemanagementlist();
        },
        sizeChangeHandle(value) { //pageSize修改
            this.pageSize = value;
            this.pageIndex = 1;
            this.apiwbschedulemanagementlist();
        },
        currentChangeHandle(value) { //pageIndex修改
            this.pageIndex = value;
            this.apiwbschedulemanagementlist();
        },
        paginationChange(obj){
         this.pageIndex= obj.page||1
         this.pageSize=obj.limit||10
         this.apiwbschedulemanagementlist();
        },
        indexMethod(index) { //序号
            return (this.pageIndex - 1) * this.pageSize + index + 1
        },
        sortChange({ column, prop, order }) { //排序
            this.sortParams.prop = prop || column.prop;
            this.sortParams.order = order || column.order;
            this.apiwbschedulemanagementlist();
        },
        filterChange(list) { //筛选
            Object.keys(list).forEach((key) => {
                if(key === 'emergencyLevel') {
                    this.emergencyLevelData = list.emergencyLevel
                }
                if(key === 'completeStatus') {
                    this.completeStatusData = list.completeStatus
                }
            })
            this.apiwbschedulemanagementlist();
        }
    }
}
</script>

<style lang="less" scoped>
.workday {
    .workday-top {
        background: #fff;
        height: 88px;
        padding: 24px 40px 40px 24px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        width: calc(100% + 48px);
        position: relative;
        left: -24px;
        >p {
            .title {
                font-size: 18px;
                font-weight: 700;
            }
        }
        .workday-search {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 24px;
            left: 50%;
            transform: translateX(-50%);
            /deep/ .el-input {
                width: 350px;
                .el-input__inner {
                    height: 40px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-right: 0;
                }
            }
            .search-btn {
                height: 40px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                font-size: 14px;
                padding: 9px 20px;
            }
        }
    }
    .table-content {
        background-color: #fff;
        margin-top:24px;
        padding: 16px;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
}
</style>